/* eslint-disable jsx-a11y/alt-text */
import React from 'react';

const iconsOptions = [
  {
    label: (
      <>
        <p>
          <b>Dashboard de Cobrança: </b>/dashboard
        </p>
      </>
    ),
    value: `/dashboard`,
  },
  {
    label: (
      <>
        <p>
          <b>Dashboard de Pagamentos: </b>/dashboard-pagamentos
        </p>
      </>
    ),
    value: `/dashboard-pagamentos`,
  },
  {
    label: (
      <>
        <p>
          <b>Dashboard de Convênios: </b>/dashboard-convenios
        </p>
      </>
    ),
    value: `/dashboard-convenios`,
  },
  {
    label: (
      <>
        <p>
          <b>Mensagens de Críticas: </b>/mensagens-criticas/listar
        </p>
      </>
    ),
    value: `/mensagens-criticas/listar`,
  },
  {
    label: (
      <>
        <p>
          <b>Telas: </b>/telas/listar
        </p>
      </>
    ),
    value: `/telas/listar`,
  },
  {
    label: (
      <>
        <p>
          <b>Perfil: </b>/perfil/listar
        </p>
      </>
    ),
    value: `/perfil/listar`,
  },
  {
    label: (
      <>
        <p>
          <b>Motor de Cobrança: </b>/motor
        </p>
      </>
    ),
    value: `/motor`,
  },
  {
    label: (
      <>
        <p>
          <b>Motor de Pagamentos: </b>/motor-pagamentos
        </p>
      </>
    ),
    value: `/motor-pagamentos`,
  },
  {
    label: (
      <>
        <p>
          <b>Motor de Convênios: </b>/motor-convenios
        </p>
      </>
    ),
    value: `/motor-convenios`,
  },
  {
    label: (
      <>
        <p>
          <b>Relatório: </b>/relatorio
        </p>
      </>
    ),
    value: `/relatorio`,
  },
  {
    label: (
      <>
        <p>
          <b>Instruções: </b>/instrucao/listar
        </p>
      </>
    ),
    value: `/instrucao/listar`,
  },
  {
    label: (
      <>
        <p>
          <b>Manuais: </b>/manual/listar
        </p>
      </>
    ),
    value: `/manual/listar`,
  },
  {
    label: (
      <>
        <p>
          <b>Perguntas: </b>/pergunta/listar
        </p>
      </>
    ),
    value: `/pergunta/listar`,
  },
];

export default iconsOptions;
